var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import ThirdPartySystemService from '../../../api/ThirdPartySystemService';
import GlobalVue from "../../../globalVue";
import EditDialog from './EditDialog';
import Detail from './Detail.vue';
import ScmDialog from './ScmDialog.vue';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 300;
        _this.scmDialogVisible = false;
        return _this;
    }
    Object.defineProperty(List.prototype, "isAllInitialized", {
        get: function () {
            return this.listData.length > 0 && this.listData.every(function (item) { return item.is_init === 1; });
        },
        enumerable: true,
        configurable: true
    });
    List.prototype.created = function () {
        this.service = ThirdPartySystemService.getInstance();
    };
    List.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
        this.getList();
    };
    List.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(Object.assign({}, __assign({}, pager))).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    List.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    List.prototype.edit = function (row) {
        var _this = this;
        var instance = this.$dialog(EditDialog, {
            data: {
                from: '1',
                data: row
            }
        }, {
            title: "编辑",
            width: 560,
            height: 440
        }).instance;
        instance.$on("editDialog:ok", function (data) {
            _this.service.save(data).then(function (res) {
                if (res.data && res.data.success) {
                    _this.$message.success(res.data.msg || '保存成功');
                    _this.getList();
                }
                else {
                    _this.$message.error(res.data.msg || '保存失败');
                }
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message || '保存失败');
            });
        });
    };
    List.prototype.preserveGood = function (row) {
        GlobalVue.$emit("addTab", {
            component: Detail,
            title: '客户—' + row.agent_warehouse_name,
            showExist: true,
            name: 'client_' + '1',
            cprops: {
                warehouseId: row.agent_warehouse_id
            }
        });
    };
    List.prototype.showScmDialog = function () {
        this.scmDialogVisible = true;
    };
    List.prototype.handleScmSubmit = function () {
        this.getList();
    };
    List = __decorate([
        Component({
            components: {
                ScmDialog: ScmDialog
            }
        })
    ], List);
    return List;
}(Vue));
export default List;
